export default function getResource(label) {
    const resources = {
        free: 'Free'
    };

    return resources[label];
}
